module.exports = __webpack_public_path__ + "img/qr_payment.5c317580.jpg";